import { HTTP } from '../http.js'

export default {
    getAll(store_id) {
        return HTTP.get(`/tradera_stores/${store_id}/sales_items`);
    },

    get(store_id, id) {
        return HTTP.get(`/tradera_stores/${store_id}/sales_items/${id}`);
    },

    post(store_id, sales_item) {
        return HTTP.post(`/tradera_stores/${store_id}/sales_items`, sales_item);
    },

    put(store_id, sales_item) {
        return HTTP.put(`/tradera_stores/${store_id}/sales_items/${sales_item.id}`, sales_item);
    },

    delete(store_id, id) {
        return HTTP.delete(`/tradera_stores/${store_id}/sales_items/${id}`);
    },

    postPart(store_id, id) {
        return HTTP.post(`/tradera_stores/${store_id}/sales_items/${id}/parts`);
    },

    deletePart(store_id, id, part_number) {
        return HTTP.delete(`/tradera_stores/${store_id}/sales_items/${id}/parts/${part_number}`);
    },

    printAll(store_id, id) {
        return HTTP.post(`/tradera_stores/${store_id}/sales_items/${id}/parts/print`);
    },

    print(store_id, id, part_number) {
        return HTTP.post(`/tradera_stores/${store_id}/sales_items/${id}/parts/${part_number}/print`);
    }
};
